<div class="shipment-History">
  <div>
    <label class="secondary-details">{{ 'configuration.emailMapping.prealertConfiguration' | translate }}</label>
    <button type="submit" class="primary-btn float-right mt-2" (click)="openEditorCreatePopup('', '', 'Create')">
      {{ 'global.create' | translate }}
    </button>
  </div>
  <div class="custom-card">
    <div class="col-12 table-container">
      <table mat-table aria-describedby="shipments-history" [dataSource]="emailData" matSort>
        <ng-container matColumnDef="Destination">
          <th id="Destination" mat-header-cell *matHeaderCellDef>{{ 'configuration.emailMapping.destinationCountryName'
            | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.Destination }}</td>
        </ng-container>

        <ng-container matColumnDef="babyDestServiceCode">
          <th id="babyDestServiceCode" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.emailMapping.destinationServiceCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.babyDestServiceCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <th id="shipmentDetails" mat-header-cell *matHeaderCellDef>{{ 'configuration.emailMapping.companyName' |
            translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.companyName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="commercialInvoice">
          <th id="shipmentDetails" mat-header-cell *matHeaderCellDef>{{ 'configuration.emailMapping.commercialInvoice' |
            translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.commercialInvoice }}
          </td>
        </ng-container>
        <ng-container matColumnDef="reportparams">
          <th id="shipmentDetails" mat-header-cell *matHeaderCellDef>{{ 'configuration.emailMapping.reportParams' |
            translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.reportparams }}
          </td>
        </ng-container>
        reportparams

        <ng-container matColumnDef="action">
          <th id="action" mat-header-cell *matHeaderCellDef> {{ 'global.action' | translate }}</th>
          <td mat-cell *matCellDef="let element; let index = index">
            <i matTooltip="{{ 'configuration.emailMapping.toolTip.edit' | translate }}" class="m-1 icon-mat bi bi-pen"
              (click)="openEditorCreatePopup(element, index, 'Edit')"></i>
            <i matTooltip="{{ 'configuration.emailMapping.toolTip.delete' | translate }}"
              class="m-1 icon-mat bi bi-trash" (click)="deleteEmailConfig(element)"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{ 'global.noDataAvailable' | translate }}
        </tr>
      </table>
    </div>
  </div>
</div>